<template>
  <div>
    <AppBar @setDrawer="drawer = $event" :drawer="drawer" />
    <LeftBar @setDrawerResponsiveness="drawer = $event" :drawer="drawer" />
    <v-container class="pa-8">
      <router-view></router-view>
    </v-container>
  </div>
</template>
<script>
import AppBar from "./AppBar.vue";
import LeftBar from "./LeftBar.vue";
export default {
  components: {
    AppBar,
    LeftBar,
  },
  name: "App",

  data: () => ({
    drawer: true,
  }),
};
</script>
